export const TABLET_BREAKPOINT = 768;
